import styled from "styled-components";

const Button = styled.button`
  background: #4e95e8;
  color: white;
  padding: 10px;
  border: none;
  font-size: 16px;
  margin: 10px auto;
  font-weight: bold;
  cursor: pointer;
  :hover {
    background: #3486ea;
  }
`;

export default Button;
